import { boot } from 'quasar/wrappers'

const months = [
  'Enero',
  'Febrero',
  'Marzo',
  'Abril',
  'Mayo',
  'Junio',
  'Julio',
  'Agosto',
  'Septiembre',
  'Octubre',
  'Noviembre',
  'Diciembre',
]

export default boot(({ app }) => {
  const vars = {
    months,
  }
  app.config.globalProperties.$static = vars
})

